import { Container, Stack, Text, Title } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

export function AppNotFound() {
  const { t } = useTranslation();
  return (
    <Container size="sm">
      <Stack gap={16}>
        <Title size="lg">{t("marketplace.notFoundTitle")}</Title>
        <Text tone="subtle">{t("marketplace.notFoundDescription")}</Text>
      </Stack>
    </Container>
  );
}
